import { useCommonWidgetHandlers } from './use-common-widget-handlers';
import { Dispatch } from 'redux';
import { StoreState } from '@mm/state/store-interfaces';
import { useDispatch } from 'react-redux';
import VideoWidget from '../../../editor/features/build/requestModels/widgets/VideoWidget';
import WidgetModel from '@mm/state/model/WidgetModel';
import { uploadVideo } from '@mm/state/actions/uploadActions';

export const useVideoWidgetHandlers = () => {
  const commonWidgetHandlers = useCommonWidgetHandlers();
  const dispatch: Dispatch<StoreState> = useDispatch();

  const addVideoToWidget = async (widget: WidgetModel, file: File) => {
    const id = await dispatch(
      uploadVideo({
        content: file,
        extension: file.name.split('.').pop() || '',
      }),
    );

    await commonWidgetHandlers.update({
      ...widget,
      config: {
        ...widget.config,
        assetId: id,
        description: file.name,
      },
    });
  };

  const addNew = (dialogueId: number, sortOrder: number) => {
    const newWidget = VideoWidget.make(dialogueId, sortOrder);

    return commonWidgetHandlers.create(newWidget, dialogueId, sortOrder);
  };

  return {
    delete: commonWidgetHandlers.delete,
    addNew,
    addVideoToWidget,
  };
};
